export const OAUTH2_CLIENT_ID = 'web'
export const OAUTH2_CALLBACK_URL = '/web/api/auth/callback'

export enum NewsletterSubscription {
  OptIn = 'opt_in',
  OptOut = 'opt_out',
  WithTerms = 'with_terms',
}
